import React from 'react';
import "./Style.css"

const Contact: React.FC = () => {

  const handleLinkClick = async (link: string) => {
    console.log(`User clicked on the link: ${link}`);
  
    // Send log to API (for example, Vercel)
    await fetch('/api/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ link, timestamp: new Date().toISOString() }),
    });
  };

  return (
    <section className="body">
      <hr className="custom-line" />
      
      <div className="text-container">
        <p>
          Tablourile sunt personalizate în funcție de dorința fiecăruia, astfel, dimensiunile, culorile, modelele se pot schimba.
        </p>
        <p>
          Mă poți contacta la 
          <a 
            href="tel:0744420683" 
            aria-label="Call me at 0744 420 683"
            onClick={() => handleLinkClick('0744 420 683')}>
            <b> 0744 420 683</b>
          </a>
        </p>
        <p>
          Urmărește-mă pe Instagram: 
          <a 
            href="https://www.instagram.com/paintingsbyclaudiu/" 
            target="_blank" 
            rel="noopener noreferrer" 
            aria-label="Visit my Instagram profile @paintingsbyclaudiu"
            onClick={() => handleLinkClick('@paintingsbyclaudiu')}>
            <b> @paintingsbyclaudiu</b>
          </a>
        </p>
      </div>
    </section>
  );
};

export default Contact;
